import { Application } from "@hotwired/stimulus";
import { controllers } from "@joemasilotti/bridge-components";

const application = Application.start();

import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll);

application.load(controllers);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };
